import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { Toaster } from "ngx-toast-notifications";
import { TranslateService } from '@ngx-translate/core';
import { defaultLanguage } from 'src/app/app.default.language';

@Injectable()
export class ToastProvider {
  isAlready = false;
  constructor(
    private toaster: Toaster,
    private translateService: TranslateService
  ) { }

  async success(title?: any) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });

    Toast.fire({
      icon: 'success',
      title: title ? title : await this.getText('WORKPLUS.WORDING.SUCCESS')
    });
  }

  async serviceError(res: any) {
    const ln = window.localStorage.getItem('languages');
    const msg = ln === 'th' ? res.MessageAlt : res.Message;

    this.toaster.open({
      caption: await this.getText('WORKPLUS.WORDING.ERROR'),
      text: msg,
      type: 'danger',
    });
  }

  async internalError() {
    if (!this.isAlready) {
      this.isAlready = true;
      // this.toaster.open({
      //   text: await this.getText('WORKPLUS.SHARED.PLEASE_CONTACT_ADMIN'),
      //   type: 'warning',
      // });
    }
  }

  async error(key: any) {
    if (!this.isAlready) {

      this.isAlready = true;
      let msg = '';
      const caption = await this.getText('WORKPLUS.WORDING.ERROR');
      if (Array.isArray(key)) {
        for (let i = 0; i < key.length; i++) {
          msg += (await this.getText(key[i])) + ' ';
        }
      } else {
        msg = await this.getText(key);
      }
      this.toaster.open({
        caption,
        text: msg,
        type: 'danger',
      });
    }

  }

  async warning(key: any) {
    if (!this.isAlready) {
      this.isAlready = true;
      let msg = '';
      let caption = await this.getText('WORKPLUS.SHARED.WARNING');
      if (Array.isArray(key)) {
        for (let i = 0; i < key.length; i++) {
          msg += (await this.getText(key[i])) + ' ';
        }
      } else {
        msg = await this.getText(key);
      }
      this.toaster.open({
        caption,
        text: msg,
        type: 'warning',
      });
    }

  }

  toastSuccess(title: any) {
    this.toaster.open({
      text: title,
      type: 'success',
    });
  }

  async toastError(param: ConfigParam) {
    if (!this.isAlready) {
      this.isAlready = true;
      let caption = await this.getText('WORKPLUS.WORDING.ERROR');
      this.toaster.open({
        caption: param.caption ? param.caption : caption,
        text: 'Something was wrong',
        type: 'warning',
      });
    }
  }

  async toastServiceError(param: ConfigParam) {
    if (!this.isAlready) {
      this.isAlready = true;
      let caption = await this.getText('WORKPLUS.WORDING.ERROR');
      this.toaster.open({
        caption: param.caption ? param.caption : "",
        text: param.text,
        type: 'warning',
      });

      setTimeout(() => {
        this.isAlready = false;
      }, 1000);
    }
  }

  async toastWarning(param: ConfigParam) {
    if (!this.isAlready) {
      this.isAlready = true;
      let caption = await this.getText('WORKPLUS.SHARED.WARNING');
      this.toaster.open({
        caption: param.caption ? param.caption : caption,
        text: param.text,
        type: 'warning',
      });
      setTimeout(() => {
        this.isAlready = false;
      }, 1000);
    }
    
  }

  private getText(key?: any): Promise<any> {
    return new Promise(async (resovle) => {
      let msg = await this.translateService.get(key).toPromise();
      if (msg == key) {
        msg = defaultLanguage[msg];
      }
      resovle(msg);
    });
  }

}

export class ConfigParam {
  caption?;
  text
}
